import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Sync Index Route
 *
 * Route: /:locale/sync/
 */
export const Route = createFileRoute('/$locale/_authenticated/sync/')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/$locale/sync/data-types',
      params: { locale: params.locale },
    });
  },
});
